/* ============================================================
   BLOOM — Interaction & Animation Engine (redesign)
   Vanilla JS · GPU-friendly · prefers-reduced-motion aware
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Scroll-reveal */
  function initReveal() {
    var selector =
      '.bloom-section-header, .bloom-cat-card, .bloom-ebook-card, ' +
      '.bloom-feature-card, .bloom-about-inner, .bloom-kb-card, ' +
      '.bloom-reveal, .bloom-news-inner';
    var nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    nodes.forEach(function (el) { io.observe(el); });
  }

  /* 2. Count-up numbers */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = 1400;
    var start = null;
    if (reduceMotion) { el.textContent = target + suffix; return; }
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target + suffix;
    }
    requestAnimationFrame(step);
  }
  function initCounters() {
    var counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;
    if (!('IntersectionObserver' in window)) { counters.forEach(countUp); return; }
    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { countUp(entry.target); obs.unobserve(entry.target); }
        });
      },
      { threshold: 0.6 }
    );
    counters.forEach(function (el) { io.observe(el); });
  }

  /* 3. Scroll progress bar */
  function initProgress() {
    if (reduceMotion) return;
    var bar = document.createElement('div');
    bar.className = 'bloom-scroll-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var height = h.scrollHeight - h.clientHeight;
      var pct = height > 0 ? (h.scrollTop / height) : 0;
      bar.style.transform = 'scaleX(' + pct + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* 4. Hero parallax */
  function initParallax() {
    if (reduceMotion) return;
    if (window.innerWidth < 768) return;
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length) return;
    var ticking = false;
    function update() {
      var y = window.pageYOffset;
      els.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.12;
        el.style.transform = 'translate3d(0,' + (-y * speed).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* 5. Button ripple */
  function initRipple() {
    if (reduceMotion) return;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ripple]');
      if (!btn) return;
      var rect = btn.getBoundingClientRect();
      var circle = document.createElement('span');
      var size = Math.max(rect.width, rect.height);
      circle.className = 'bloom-ripple';
      circle.style.width = circle.style.height = size + 'px';
      circle.style.left = e.clientX - rect.left - size / 2 + 'px';
      circle.style.top = e.clientY - rect.top - size / 2 + 'px';
      btn.appendChild(circle);
      setTimeout(function () { circle.remove(); }, 650);
    });
  }

  /* 6. Newsletter micro-interaction */
  function initNewsletter() {
    var forms = document.querySelectorAll('.bloom-news-form');
    forms.forEach(function (form) {
      var input = form.querySelector('input[type="email"]');
      if (!input) return;
      function sync() { form.classList.toggle('has-value', input.value.trim() !== ''); }
      input.addEventListener('input', sync);
      input.addEventListener('focus', function () { form.classList.add('is-focused'); });
      input.addEventListener('blur', function () { form.classList.remove('is-focused'); sync(); });
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"]');
        if (btn) btn.classList.add('is-loading');
      });
      sync();
    });
  }

  function boot() {
    initReveal();
    initCounters();
    initProgress();
    initParallax();
    initRipple();
    initNewsletter();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
